function cov_1ovayb7x80() {
  var path = "/app/src/components/default-promo-widget/components/ltf-snippet/ltf-snippet.tsx";
  var hash = "eb227ce39bee3245f6a06062e5803c219d490364";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/app/src/components/default-promo-widget/components/ltf-snippet/ltf-snippet.tsx",
    statementMap: {
      "0": {
        start: {
          line: 20,
          column: 27
        },
        end: {
          line: 22,
          column: 1
        }
      },
      "1": {
        start: {
          line: 21,
          column: 8
        },
        end: {
          line: 21,
          column: 48
        }
      },
      "2": {
        start: {
          line: 28,
          column: 26
        },
        end: {
          line: 202,
          column: 1
        }
      },
      "3": {
        start: {
          line: 35,
          column: 6
        },
        end: {
          line: 35,
          column: 21
        }
      },
      "4": {
        start: {
          line: 36,
          column: 12
        },
        end: {
          line: 36,
          column: 23
        }
      },
      "5": {
        start: {
          line: 38,
          column: 24
        },
        end: {
          line: 41,
          column: 13
        }
      },
      "6": {
        start: {
          line: 43,
          column: 18
        },
        end: {
          line: 43,
          column: 56
        }
      },
      "7": {
        start: {
          line: 46,
          column: 4
        },
        end: {
          line: 46,
          column: 66
        }
      },
      "8": {
        start: {
          line: 48,
          column: 27
        },
        end: {
          line: 48,
          column: 72
        }
      },
      "9": {
        start: {
          line: 49,
          column: 21
        },
        end: {
          line: 49,
          column: 39
        }
      },
      "10": {
        start: {
          line: 51,
          column: 36
        },
        end: {
          line: 54,
          column: 3
        }
      },
      "11": {
        start: {
          line: 53,
          column: 41
        },
        end: {
          line: 53,
          column: 60
        }
      },
      "12": {
        start: {
          line: 56,
          column: 30
        },
        end: {
          line: 63,
          column: 3
        }
      },
      "13": {
        start: {
          line: 58,
          column: 6
        },
        end: {
          line: 61,
          column: 18
        }
      },
      "14": {
        start: {
          line: 65,
          column: 18
        },
        end: {
          line: 188,
          column: 3
        }
      },
      "15": {
        start: {
          line: 66,
          column: 32
        },
        end: {
          line: 68,
          column: 42
        }
      },
      "16": {
        start: {
          line: 68,
          column: 22
        },
        end: {
          line: 68,
          column: 41
        }
      },
      "17": {
        start: {
          line: 70,
          column: 4
        },
        end: {
          line: 187,
          column: 5
        }
      },
      "18": {
        start: {
          line: 72,
          column: 8
        },
        end: {
          line: 87,
          column: 10
        }
      },
      "19": {
        start: {
          line: 89,
          column: 8
        },
        end: {
          line: 96,
          column: 10
        }
      },
      "20": {
        start: {
          line: 98,
          column: 8
        },
        end: {
          line: 117,
          column: 10
        }
      },
      "21": {
        start: {
          line: 109,
          column: 38
        },
        end: {
          line: 109,
          column: 63
        }
      },
      "22": {
        start: {
          line: 110,
          column: 34
        },
        end: {
          line: 110,
          column: 66
        }
      },
      "23": {
        start: {
          line: 120,
          column: 40
        },
        end: {
          line: 120,
          column: 62
        }
      },
      "24": {
        start: {
          line: 122,
          column: 22
        },
        end: {
          line: 131,
          column: 13
        }
      },
      "25": {
        start: {
          line: 133,
          column: 8
        },
        end: {
          line: 151,
          column: 10
        }
      },
      "26": {
        start: {
          line: 143,
          column: 38
        },
        end: {
          line: 143,
          column: 63
        }
      },
      "27": {
        start: {
          line: 144,
          column: 34
        },
        end: {
          line: 144,
          column: 66
        }
      },
      "28": {
        start: {
          line: 154,
          column: 8
        },
        end: {
          line: 164,
          column: 10
        }
      },
      "29": {
        start: {
          line: 166,
          column: 8
        },
        end: {
          line: 177,
          column: 10
        }
      },
      "30": {
        start: {
          line: 179,
          column: 8
        },
        end: {
          line: 186,
          column: 10
        }
      },
      "31": {
        start: {
          line: 190,
          column: 28
        },
        end: {
          line: 192,
          column: 10
        }
      },
      "32": {
        start: {
          line: 194,
          column: 2
        },
        end: {
          line: 201,
          column: 4
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 21,
            column: 2
          },
          end: {
            line: 21,
            column: 3
          }
        },
        loc: {
          start: {
            line: 21,
            column: 8
          },
          end: {
            line: 21,
            column: 48
          }
        },
        line: 21
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 28,
            column: 26
          },
          end: {
            line: 28,
            column: 27
          }
        },
        loc: {
          start: {
            line: 28,
            column: 50
          },
          end: {
            line: 202,
            column: 1
          }
        },
        line: 28
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 53,
            column: 30
          },
          end: {
            line: 53,
            column: 31
          }
        },
        loc: {
          start: {
            line: 53,
            column: 41
          },
          end: {
            line: 53,
            column: 60
          }
        },
        line: 53
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 57,
            column: 4
          },
          end: {
            line: 57,
            column: 5
          }
        },
        loc: {
          start: {
            line: 58,
            column: 6
          },
          end: {
            line: 61,
            column: 18
          }
        },
        line: 58
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 65,
            column: 18
          },
          end: {
            line: 65,
            column: 19
          }
        },
        loc: {
          start: {
            line: 65,
            column: 24
          },
          end: {
            line: 188,
            column: 3
          }
        },
        line: 65
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 68,
            column: 12
          },
          end: {
            line: 68,
            column: 13
          }
        },
        loc: {
          start: {
            line: 68,
            column: 22
          },
          end: {
            line: 68,
            column: 41
          }
        },
        line: 68
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 109,
            column: 26
          },
          end: {
            line: 109,
            column: 27
          }
        },
        loc: {
          start: {
            line: 109,
            column: 38
          },
          end: {
            line: 109,
            column: 63
          }
        },
        line: 109
      },
      "7": {
        name: "(anonymous_7)",
        decl: {
          start: {
            line: 110,
            column: 28
          },
          end: {
            line: 110,
            column: 29
          }
        },
        loc: {
          start: {
            line: 110,
            column: 34
          },
          end: {
            line: 110,
            column: 66
          }
        },
        line: 110
      },
      "8": {
        name: "(anonymous_8)",
        decl: {
          start: {
            line: 143,
            column: 26
          },
          end: {
            line: 143,
            column: 27
          }
        },
        loc: {
          start: {
            line: 143,
            column: 38
          },
          end: {
            line: 143,
            column: 63
          }
        },
        line: 143
      },
      "9": {
        name: "(anonymous_9)",
        decl: {
          start: {
            line: 144,
            column: 28
          },
          end: {
            line: 144,
            column: 29
          }
        },
        loc: {
          start: {
            line: 144,
            column: 34
          },
          end: {
            line: 144,
            column: 66
          }
        },
        line: 144
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 32,
            column: 28
          },
          end: {
            line: 32,
            column: 51
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 32,
            column: 49
          },
          end: {
            line: 32,
            column: 51
          }
        }],
        line: 32
      },
      "1": {
        loc: {
          start: {
            line: 46,
            column: 4
          },
          end: {
            line: 46,
            column: 66
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 46,
            column: 26
          },
          end: {
            line: 46,
            column: 61
          }
        }, {
          start: {
            line: 46,
            column: 64
          },
          end: {
            line: 46,
            column: 66
          }
        }],
        line: 46
      },
      "2": {
        loc: {
          start: {
            line: 48,
            column: 27
          },
          end: {
            line: 48,
            column: 72
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 48,
            column: 27
          },
          end: {
            line: 48,
            column: 59
          }
        }, {
          start: {
            line: 48,
            column: 63
          },
          end: {
            line: 48,
            column: 72
          }
        }],
        line: 48
      },
      "3": {
        loc: {
          start: {
            line: 58,
            column: 6
          },
          end: {
            line: 61,
            column: 18
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 60,
            column: 10
          },
          end: {
            line: 60,
            column: 15
          }
        }, {
          start: {
            line: 61,
            column: 10
          },
          end: {
            line: 61,
            column: 18
          }
        }],
        line: 58
      },
      "4": {
        loc: {
          start: {
            line: 58,
            column: 6
          },
          end: {
            line: 59,
            column: 65
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 58,
            column: 6
          },
          end: {
            line: 58,
            column: 32
          }
        }, {
          start: {
            line: 59,
            column: 7
          },
          end: {
            line: 59,
            column: 16
          }
        }, {
          start: {
            line: 59,
            column: 20
          },
          end: {
            line: 59,
            column: 64
          }
        }],
        line: 58
      },
      "5": {
        loc: {
          start: {
            line: 70,
            column: 4
          },
          end: {
            line: 187,
            column: 5
          }
        },
        type: "switch",
        locations: [{
          start: {
            line: 71,
            column: 6
          },
          end: {
            line: 87,
            column: 10
          }
        }, {
          start: {
            line: 88,
            column: 6
          },
          end: {
            line: 96,
            column: 10
          }
        }, {
          start: {
            line: 97,
            column: 6
          },
          end: {
            line: 118,
            column: 7
          }
        }, {
          start: {
            line: 119,
            column: 6
          },
          end: {
            line: 152,
            column: 7
          }
        }, {
          start: {
            line: 153,
            column: 6
          },
          end: {
            line: 164,
            column: 10
          }
        }, {
          start: {
            line: 165,
            column: 6
          },
          end: {
            line: 177,
            column: 10
          }
        }, {
          start: {
            line: 178,
            column: 6
          },
          end: {
            line: 186,
            column: 10
          }
        }],
        line: 70
      },
      "6": {
        loc: {
          start: {
            line: 73,
            column: 16
          },
          end: {
            line: 85,
            column: 11
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 76,
            column: 12
          },
          end: {
            line: 80,
            column: 19
          }
        }, {
          start: {
            line: 82,
            column: 12
          },
          end: {
            line: 84,
            column: 19
          }
        }],
        line: 73
      },
      "7": {
        loc: {
          start: {
            line: 97,
            column: 11
          },
          end: {
            line: 97,
            column: 76
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 97,
            column: 11
          },
          end: {
            line: 97,
            column: 26
          }
        }, {
          start: {
            line: 97,
            column: 30
          },
          end: {
            line: 97,
            column: 49
          }
        }, {
          start: {
            line: 97,
            column: 53
          },
          end: {
            line: 97,
            column: 76
          }
        }],
        line: 97
      },
      "8": {
        loc: {
          start: {
            line: 119,
            column: 11
          },
          end: {
            line: 119,
            column: 49
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 119,
            column: 11
          },
          end: {
            line: 119,
            column: 26
          }
        }, {
          start: {
            line: 119,
            column: 30
          },
          end: {
            line: 119,
            column: 49
          }
        }],
        line: 119
      },
      "9": {
        loc: {
          start: {
            line: 122,
            column: 22
          },
          end: {
            line: 131,
            column: 13
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 123,
            column: 12
          },
          end: {
            line: 123,
            column: 72
          }
        }, {
          start: {
            line: 124,
            column: 12
          },
          end: {
            line: 131,
            column: 13
          }
        }],
        line: 122
      },
      "10": {
        loc: {
          start: {
            line: 153,
            column: 11
          },
          end: {
            line: 153,
            column: 75
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 153,
            column: 12
          },
          end: {
            line: 153,
            column: 26
          }
        }, {
          start: {
            line: 153,
            column: 30
          },
          end: {
            line: 153,
            column: 48
          }
        }, {
          start: {
            line: 153,
            column: 53
          },
          end: {
            line: 153,
            column: 75
          }
        }],
        line: 153
      },
      "11": {
        loc: {
          start: {
            line: 159,
            column: 18
          },
          end: {
            line: 159,
            column: 71
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 159,
            column: 18
          },
          end: {
            line: 159,
            column: 43
          }
        }, {
          start: {
            line: 159,
            column: 47
          },
          end: {
            line: 159,
            column: 71
          }
        }],
        line: 159
      },
      "12": {
        loc: {
          start: {
            line: 165,
            column: 11
          },
          end: {
            line: 165,
            column: 72
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 165,
            column: 12
          },
          end: {
            line: 165,
            column: 26
          }
        }, {
          start: {
            line: 165,
            column: 30
          },
          end: {
            line: 165,
            column: 48
          }
        }, {
          start: {
            line: 165,
            column: 53
          },
          end: {
            line: 165,
            column: 72
          }
        }],
        line: 165
      },
      "13": {
        loc: {
          start: {
            line: 171,
            column: 18
          },
          end: {
            line: 171,
            column: 71
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 171,
            column: 18
          },
          end: {
            line: 171,
            column: 43
          }
        }, {
          start: {
            line: 171,
            column: 47
          },
          end: {
            line: 171,
            column: 71
          }
        }],
        line: 171
      },
      "14": {
        loc: {
          start: {
            line: 190,
            column: 28
          },
          end: {
            line: 192,
            column: 10
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 191,
            column: 4
          },
          end: {
            line: 191,
            column: 51
          }
        }, {
          start: {
            line: 192,
            column: 6
          },
          end: {
            line: 192,
            column: 10
          }
        }],
        line: 190
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0,
      "31": 0,
      "32": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0
    },
    b: {
      "0": [0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0, 0],
      "5": [0, 0, 0, 0, 0, 0, 0],
      "6": [0, 0],
      "7": [0, 0, 0],
      "8": [0, 0],
      "9": [0, 0],
      "10": [0, 0, 0],
      "11": [0, 0],
      "12": [0, 0, 0],
      "13": [0, 0],
      "14": [0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "eb227ce39bee3245f6a06062e5803c219d490364"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_1ovayb7x80 = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_1ovayb7x80();
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
import React from 'react';
import { lazily } from 'react-lazily';
import { Currency } from 'src/components/currency';
import { SubventionOffer } from 'src/components/default-promo-widget/components/ltf-snippet/components/subvention-offer/subvention-offer';
import { COUNTRY_NAME_BY_CURRENCY_MAP } from 'src/constants/country-name-by-currency-map';
import { INSTALLMENT_PLANS, INSTALLMENTS_COUNT_LIST_FOR_DEFAULT_PROMO } from 'src/constants/learn-more';
import { useAppContext } from 'src/context/store/app-provider';
import { useGetSubvention } from 'src/hooks/use-get-subvention';
import { useLocale } from 'src/hooks/use-locale';
import { createNormalizeCheckingNumber } from 'src/utils/create-normalize-checking-number';
import { calculatePriceWithFees } from 'src/utils/default-fees-calculator';
import { getFormattedAmount } from 'src/utils/get-formatted-amount';
import { getPriceSplitOf } from 'src/utils/get-price-split-of';
import styles from './styles.css';
var _ref = (cov_1ovayb7x80().s[0]++, lazily(function () {
    cov_1ovayb7x80().f[0]++;
    cov_1ovayb7x80().s[1]++;
    return import('src/components/snippet-default');
  })),
  SnippetDefault = _ref.SnippetDefault;
cov_1ovayb7x80().s[2]++;
export var LtfSnippet = function LtfSnippet(_ref2) {
  var onClick = _ref2.onClick;
  cov_1ovayb7x80().f[1]++;
  var _ref3 = (cov_1ovayb7x80().s[3]++, useAppContext()),
    _currency = _ref3.currency,
    priceRaw = _ref3.priceRaw,
    _ref3$offers$installm = _ref3.offers.installments,
    offersInstallments = _ref3$offers$installm === void 0 ? (cov_1ovayb7x80().b[0][0]++, []) : _ref3$offers$installm,
    installmentsCount = _ref3.installmentsCount,
    getExperiment = _ref3.getExperiment;
  var t = (cov_1ovayb7x80().s[4]++, useLocale());
  var preparedPrice = (cov_1ovayb7x80().s[5]++, createNormalizeCheckingNumber('Price argument is not a number', 0)(priceRaw));
  var country = (cov_1ovayb7x80().s[6]++, COUNTRY_NAME_BY_CURRENCY_MAP[_currency]);
  var shariahText = (cov_1ovayb7x80().s[7]++, country === 'saudi' ? (cov_1ovayb7x80().b[1][0]++, "".concat(t('default.shariahCompliant'), ".")) : (cov_1ovayb7x80().b[1][1]++, ''));
  var payNowExperiment = (cov_1ovayb7x80().s[8]++, (cov_1ovayb7x80().b[2][0]++, getExperiment('CT-2431-pay-now')) || (cov_1ovayb7x80().b[2][1]++, 'control'));
  var subvention = (cov_1ovayb7x80().s[9]++, useGetSubvention());
  var longestOfferPaymentsCount = (cov_1ovayb7x80().s[10]++, Math.max.apply(Math, [0].concat(_toConsumableArray(offersInstallments.map(function (offer) {
    cov_1ovayb7x80().f[2]++;
    cov_1ovayb7x80().s[11]++;
    return offer.paymentsCount;
  })))));
  var offerWithSubvention = (cov_1ovayb7x80().s[12]++, offersInstallments.reduce(function (maxOffer, offer) {
    cov_1ovayb7x80().f[3]++;
    cov_1ovayb7x80().s[13]++;
    return (cov_1ovayb7x80().b[4][0]++, offer.subventionCampaignId) && ((cov_1ovayb7x80().b[4][1]++, !maxOffer) || (cov_1ovayb7x80().b[4][2]++, offer.paymentsCount > maxOffer.paymentsCount)) ? (cov_1ovayb7x80().b[3][0]++, offer) : (cov_1ovayb7x80().b[3][1]++, maxOffer);
  }, undefined));
  cov_1ovayb7x80().s[14]++;
  var getText = function getText() {
    cov_1ovayb7x80().f[4]++;
    var sortedPlansByAmount = (cov_1ovayb7x80().s[15]++, offersInstallments.slice().sort(function (a, b) {
      cov_1ovayb7x80().f[5]++;
      cov_1ovayb7x80().s[16]++;
      return a.amount - b.amount;
    }));
    cov_1ovayb7x80().s[17]++;
    switch (true) {
      case payNowExperiment === 'group1':
        cov_1ovayb7x80().b[5][0]++;
        cov_1ovayb7x80().s[18]++;
        return {
          text: INSTALLMENTS_COUNT_LIST_FOR_DEFAULT_PROMO.includes(installmentsCount) ? (cov_1ovayb7x80().b[6][0]++, /*#__PURE__*/React.createElement("span", {
            className: styles.messagePayInto
          }, t('default.split_into', {
            installmentsCount: installmentsCount
          }))) : (cov_1ovayb7x80().b[6][1]++, /*#__PURE__*/React.createElement("span", {
            className: styles.messagePayInto
          }, t('split_your_purchase'))),
          link: t('default.learnMore')
        };
      case payNowExperiment === 'group2':
        cov_1ovayb7x80().b[5][1]++;
        cov_1ovayb7x80().s[19]++;
        return {
          text: /*#__PURE__*/React.createElement("span", {
            className: styles.messagePayInto
          }, t('default.pay_with_tabby')),
          link: t('default.learnMore')
        };
      case (cov_1ovayb7x80().b[7][0]++, !!preparedPrice) && (cov_1ovayb7x80().b[7][1]++, !!installmentsCount) && (cov_1ovayb7x80().b[7][2]++, subvention.isSubvention):
        cov_1ovayb7x80().b[5][2]++;
        {
          var _subvention$longestSu, _subvention$longestSu2;
          cov_1ovayb7x80().s[20]++;
          return {
            text: /*#__PURE__*/React.createElement("span", {
              className: styles.message
            }, t('split_your_purchase_into_x_interest_free_payments', {
              installmentsCount: (_subvention$longestSu = subvention.longestSubventionPlan) === null || _subvention$longestSu === void 0 ? void 0 : _subvention$longestSu.paymentsCount,
              price: (_subvention$longestSu2 = subvention.longestSubventionPlan) === null || _subvention$longestSu2 === void 0 ? void 0 : _subvention$longestSu2.amount
            }, {
              strong: function strong(string) {
                cov_1ovayb7x80().f[6]++;
                cov_1ovayb7x80().s[21]++;
                return /*#__PURE__*/React.createElement("strong", null, string);
              },
              currency: function currency() {
                cov_1ovayb7x80().f[7]++;
                cov_1ovayb7x80().s[22]++;
                return /*#__PURE__*/React.createElement(Currency, {
                  currency: _currency
                });
              }
            }), ' ', shariahText),
            link: /*#__PURE__*/React.createElement("span", null, t('default.learnMore'))
          };
        }
      case (cov_1ovayb7x80().b[8][0]++, !!preparedPrice) && (cov_1ovayb7x80().b[8][1]++, !!installmentsCount):
        cov_1ovayb7x80().b[5][3]++;
        {
          var cheapestInstallmentPlan = (cov_1ovayb7x80().s[23]++, sortedPlansByAmount[0]);
          var price = (cov_1ovayb7x80().s[24]++, cheapestInstallmentPlan !== null && cheapestInstallmentPlan !== void 0 && cheapestInstallmentPlan.amount ? (cov_1ovayb7x80().b[9][0]++, getFormattedAmount(cheapestInstallmentPlan.amount, _currency)) : (cov_1ovayb7x80().b[9][1]++, getPriceSplitOf(calculatePriceWithFees({
            price: preparedPrice,
            installmentCount: INSTALLMENT_PLANS.twelve
          }), _currency, INSTALLMENT_PLANS.twelve)));
          cov_1ovayb7x80().s[25]++;
          return {
            text: /*#__PURE__*/React.createElement("span", {
              className: styles.message
            }, t('paid_plans.as_low_as_per_month_ltp', {
              installmentsCount: 4,
              price: price
            }, {
              strong: function strong(string) {
                cov_1ovayb7x80().f[8]++;
                cov_1ovayb7x80().s[26]++;
                return /*#__PURE__*/React.createElement("strong", null, string);
              },
              currency: function currency() {
                cov_1ovayb7x80().f[9]++;
                cov_1ovayb7x80().s[27]++;
                return /*#__PURE__*/React.createElement(Currency, {
                  currency: _currency
                });
              }
            }), ' ', "".concat(shariahText)),
            link: /*#__PURE__*/React.createElement("span", null, t('default.learnMore'))
          };
        }
      case ((cov_1ovayb7x80().b[10][0]++, !preparedPrice) || (cov_1ovayb7x80().b[10][1]++, !installmentsCount)) && (cov_1ovayb7x80().b[10][2]++, country === 'emirates'):
        cov_1ovayb7x80().b[5][4]++;
        cov_1ovayb7x80().s[28]++;
        return {
          text: /*#__PURE__*/React.createElement("span", null, t('split_your_purchase_in_up_to_x_monthly_payments', {
            installmentsCount: (cov_1ovayb7x80().b[11][0]++, longestOfferPaymentsCount) || (cov_1ovayb7x80().b[11][1]++, INSTALLMENT_PLANS.twelve)
          })),
          link: /*#__PURE__*/React.createElement("span", null, t('default.learnMore'))
        };
      case ((cov_1ovayb7x80().b[12][0]++, !preparedPrice) || (cov_1ovayb7x80().b[12][1]++, !installmentsCount)) && (cov_1ovayb7x80().b[12][2]++, country === 'saudi'):
        cov_1ovayb7x80().b[5][5]++;
        cov_1ovayb7x80().s[29]++;
        return {
          text: /*#__PURE__*/React.createElement("span", null, t('split_your_purchase_in_up_to_x_monthly_payments', {
            installmentsCount: (cov_1ovayb7x80().b[13][0]++, longestOfferPaymentsCount) || (cov_1ovayb7x80().b[13][1]++, INSTALLMENT_PLANS.twelve)
          }), ' ', t('default.shariahCompliant'), "."),
          link: /*#__PURE__*/React.createElement("span", null, t('default.learnMore'))
        };
      default:
        cov_1ovayb7x80().b[5][6]++;
        cov_1ovayb7x80().s[30]++;
        return {
          text: /*#__PURE__*/React.createElement("span", {
            className: styles.message
          }, t('tabbySplit.3_how_it_works')),
          link: /*#__PURE__*/React.createElement("span", null, t('default.learnMore'))
        };
    }
  };
  var additionalContent = (cov_1ovayb7x80().s[31]++, offerWithSubvention ? (cov_1ovayb7x80().b[14][0]++, /*#__PURE__*/React.createElement(SubventionOffer, {
    offer: offerWithSubvention
  })) : (cov_1ovayb7x80().b[14][1]++, null));
  cov_1ovayb7x80().s[32]++;
  return /*#__PURE__*/React.createElement(SnippetDefault, {
    message: getText().text,
    linkText: getText().link,
    onClick: onClick,
    additionalContent: additionalContent
  });
};